import { createFileRoute } from '@tanstack/react-router'
import { AgaveConnectorStatusDashboard } from '../components/agave-connector-status/AgaveConnectorStatusDashboard'

export const Route = createFileRoute('/_a/agaveConnectorStatus')({
  component: AgaveConnectorStatusDashboard,
})
